// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WA-z","smallCardRow":"XA-z","largeCardRow":"YA-z","productSearchRow":"ZA-z","curatedRow":"_A-z"};